const VOLTAGE_SCALE = 0.1;
/**
 * Voltage scaling for miller machine.
 *
 * See section 3.4.1.8
 * "The voltage command value is to be set using an integer that considers a scaling factor of 0.1. For example, a setting of 252 = 25.2V."
 */
export const convertVoltageScale = {
  /**
   * Convert to weld machine format.
   *
   * @param voltage Voltage in valid range [10,44]
   * @returns Weld machine format.
   */
  toWeldMachine: (voltage: number) => Math.round(voltage / VOLTAGE_SCALE),

  /**
   * Convert from weld machine format.
   *
   * @param voltage Weld machine format.
   * @returns Voltage.
   */
  fromWeldMachine: (voltage: number) => voltage * VOLTAGE_SCALE,
};
